export const SET_IS_PENDING = 'rpb2b-react/warranty/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_ERROR = 'rpb2b-react/warranty/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_WARRANTY_PROVIDERS =
  'rpb2b-react/warranty/SET_WARRANTY_PROVIDERS';
export type SET_WARRANTY_PROVIDERS = typeof SET_WARRANTY_PROVIDERS;

export const SET_WARRANTY_CHECKS = 'rpb2b-react/warranty/SET_WARRANTY_CHECKS';
export type SET_WARRANTY_CHECKS = typeof SET_WARRANTY_CHECKS;

export default {
  SET_IS_PENDING,
  SET_ERROR,
  SET_WARRANTY_PROVIDERS,
  SET_WARRANTY_CHECKS
};
